import { numToDecimals } from '@teinor/erp/prices'
import { WasteWeightTypesKeys } from '@teinor/erp/types/company/product'
import { useCallback, useState } from 'react'
import { ProductExtendedTyShort } from '../../../specificComponents/Product/types'
import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

type WeightInfoTy = { weight: number, calculatedWeight: number, wasteWeight: number, wasteWeightType: number }

interface WasteWeightProductProps {
    basicData?: ProductExtendedTyShort
}

const useWasteWeightProduct = ({ basicData }: WasteWeightProductProps) => {
    const { t } = useTwinTranslation()
    const [weightInfo, setWeightInfo] = useState<WeightInfoTy | null>(getWasteWeightInfo(basicData))

    const calculateWasteWeight = useCallback((data: WeightInfoTy) => {
        const copy = JSON.parse(JSON.stringify(data))
        const parsedWeight = parseFloat(copy.weight)
        const parsedWasteWeight = parseFloat(copy.wasteWeight)
        if (String(copy.wasteWeightType) === '0') {
            copy.calculatedWeight = numToDecimals(parsedWeight + ((parsedWeight * parsedWasteWeight) / 100), 8)
        } else {
            copy.calculatedWeight = numToDecimals(parsedWeight + parsedWasteWeight, 8)
        }
        return copy
    }, [])

    const handleChangeWeightInfo = useCallback((field: string, value: string) => {
        setWeightInfo((old) => {
            if (!old) {
                old = { weight: 0, calculatedWeight: 0, wasteWeight: 0, wasteWeightType: 0 }
            }
            const copyOld = JSON.parse(JSON.stringify(old))
            copyOld[field] = value
            return calculateWasteWeight(copyOld)
        })
    }, [setWeightInfo, calculateWasteWeight])


    const dictWasteWeightType: Record<WasteWeightTypesKeys, TwinDictionary> = {
        0: { name: t('percentage', 'Porcentaje'), value: 0 },
        1: { name: t('quantity', 'Cantidad'), value: 1 },
    }

    return { dictWasteWeightType, weightInfo, handleChangeWeightInfo }
}


const getWasteWeightInfo = (basicData?: ProductExtendedTyShort) => {
    if(basicData?.weight || basicData?.wasteWeight || basicData?.wasteWeightType){
        return { 
            weight: basicData?.weight || 0,
            calculatedWeight: basicData?.calculatedWeight || 0,
            wasteWeight: basicData?.wasteWeight || 0,
            wasteWeightType: basicData?.wasteWeightType || 0
        }
        
    }
    return null
}
export default useWasteWeightProduct